//===================admin=====================
import axios from "axios";

export const adminlogin = (obj) => {
    return axios
      .post("/admin/login", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const monthJob = (obj) => {
    return axios
      .get("/admin/monthlyJobCount")
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const monthAppliedJob = (obj) => {
    return axios
      .get("/admin/monthlyappliedJobCount")
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const categoryJob = (obj) => {
    return axios
      .get("/admin/categoryWiseJob")
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  export const companyJob = (obj) => {
    return axios
      .get("/admin/companywisetopjob")
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  export const functionalCandidate = (obj) => {
    return axios
      .get("/admin/functionalWiseCandidate")
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const adminchangePass = (obj) => {
    return axios
      .patch("/admin/" + obj.id + "/password", obj.data, {
        headers: { Authorization: `Bearer ${obj.token}` },
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response.data;
      });
  };
  
  export const adminforgot1 = (obj) => {
    return axios
      .post("/admin/forgetpassword", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const adminforgot2 = (obj) => {
    return axios
      .post("/admin/token-verify", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const adminforgot3 = (obj) => {
    return axios
      .post("/admin/resetPassword", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getProfile = (obj) => {
    return axios
      .get("/admin/simple/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const updateProfile = (obj) => {
    //name
    let n = axios
      .patch("/admin/" + obj.id, obj.data.name, {
        headers: { Authorization: `Bearer ${obj.token}` },
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
    //profile
    if (obj.data.profile) {
      console.log({ profile: obj.data.profile })
      n = n.then(() => {
        return axios
          .post("/admin/" + obj.id + "/profile", obj.data.profile, {
            headers: { Authorization: `Bearer ${obj.token}` },
          })
          .then((response) => {
            return response;
          })
          .catch((err) => {
            console.log("Error", err.response.data.message);
            return err.response;
          });
      })
    }
    return n
  };
  
  export const getCompanies = (obj) => {
    return axios
      .get(
        "/admin/getAllCompanyDetail?page=" +
          obj.page +
          "&page_size=" +
          obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getSixCompanies = (obj) => {
    return axios
      .get("/admin/lastsixEmployees")
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getCompanyDetails = (obj) => {
    return axios
      .get("/admin/getCompanyDetail/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getCandidates = (obj) => {
    return axios
      .get(
        "/admin/getAllCandidates?page=" + obj.page + "&page_size=" + obj.page_size + "&job_id=" + obj.job_id + "&search=" + obj.search + "&status=" + obj.status
        )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getStatusCandidates = (obj) => {
    return axios
      .get(
        "/admin/candidatestatus?page=" + obj.page + "&page_size=" + obj.page_size + "&job_id=" + obj.job_id + "&cand_id=" + obj.cand_id
        )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };

  export const getRemarkCandidates = (obj) => {
    return axios
      .get(
        "/admin/getcandidatefollowups?page=" + obj.page + "&page_size=" + obj.page_size + "&cand_status_id=" + obj.cand_status_id
        // "/admin/getcandidatefollowups/" + obj.cand_id
        )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };

  export const getCandidateDetails = (obj) => {
    return axios
      .get("/admin/getCandidateDetail/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const admingetJobs = (obj) => {
    return axios
      .get("/admin/getAlljob?page=" + obj.page + "&page_size=" + obj.page_size + "&search=" + obj.search)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getSixJobs = (obj) => {
    return axios
      .get("/admin/lastsixJobs")
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getJobDetails = (obj) => {
    return axios
      .get("/admin/getjobDetail/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getSubscribe = (obj) => {
    return axios
      .get(
        "/admin/getsubscriber_details?page=" +
          obj.page +
          "&page_size=" +
          obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllCareer = (obj) => {
    return axios
      .get(
        "/admin/getcareer_levels?page=" + obj.page + "&page_size=" + obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getCareer = (obj) => {
    return axios
      .get("/admin/editcareer_levels/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addCareer = (obj) => {
    return axios
      .post("/admin/Addcareer_levels", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editCareer = (obj) => {
    return axios
      .patch("/admin/updatePartiCularCreer_levels/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteCareer = (obj) => {
    return axios
      .get("/admin/Career_levels/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllSize = (obj) => {
    return axios
      .get(
        "/admin/getCompanySize?page=" + obj.page + "&page_size=" + obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getSize = (obj) => {
    return axios
      .get("/admin/editCompanySize/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addSize = (obj) => {
    return axios
      .post("/admin/AddCompanySize", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editSize = (obj) => {
    return axios
      .patch("/admin/editPartiCularCompany_Size/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteSize = (obj) => {
    return axios
      .get("/admin/CompanySize/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllDegree = (obj) => {
    return axios
      .get(
        "/admin/getDegreeLevel?page=" + obj.page + "&page_size=" + obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getDegree = (obj) => {
    return axios
      .get("/admin/editDegreeLevel/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addDegree = (obj) => {
    return axios
      .post("/admin/addDegreeLevel", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editDegree = (obj) => {
    return axios
      .patch("/admin/editPartiCulardegree_levels/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteDegree = (obj) => {
    return axios
      .get("/admin/DegreeLevel/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllFunctional = (obj) => {
    return axios
      .get(
        "/admin/getFunctionalArea?page=" +
          obj.page +
          "&page_size=" +
          obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getFunctional = (obj) => {
    return axios
      .get("/admin/editFunctionalArea/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addFunctional = (obj) => {
    return axios
      .post("/admin/addFunctionalArea", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editFunctional = (obj) => {
    return axios
      .patch("/admin/editPartiCularFunctionalArea/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteFunctional = (obj) => {
    return axios
      .get("/admin/FunctionalArea/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllIndustry = (obj) => {
    return axios
      .get("/admin/getIndustry?page=" + obj.page + "&page_size=" + obj.page_size)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getIndustry = (obj) => {
    return axios
      .get("/admin/editIndustry/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addIndustry = (obj) => {
    return axios
      .post("/admin/addIndustry", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editIndustry = (obj) => {
    return axios
      .patch("/admin/editPartiCularIndustry/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteIndustry = (obj) => {
    return axios
      .get("/admin/Industry/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllCategory = (obj) => {
    return axios
      .get(
        "/admin/getJobCategory?page=" + obj.page + "&page_size=" + obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getCategory = (obj) => {
    return axios
      .get("/admin/editJobCategory/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addCategory = (obj) => {
    return axios
      .post("/admin/addJobCategory", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editCategory = (obj) => {
    return axios
      .patch("/admin/editPartiCularJobCategory/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteCategory = (obj) => {
    return axios
      .get("/admin/JobCategory/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllTag = (obj) => {
    return axios
      .get("/admin/getjob_tags?page=" + obj.page + "&page_size=" + obj.page_size)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getTag = (obj) => {
    return axios
      .get("/admin/editjob_tags/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addTag = (obj) => {
    return axios
      .post("/admin/addjob_tags", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editTag = (obj) => {
    return axios
      .patch("/admin/editPartiCularjob_tags/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteTag = (obj) => {
    return axios
      .get("/admin/job_tags/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllShift = (obj) => {
    return axios
      .get(
        "/admin/getjob_shifts?page=" + obj.page + "&page_size=" + obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getShift = (obj) => {
    return axios
      .get("/admin/editjob_shifts/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addShift = (obj) => {
    return axios
      .post("/admin/addjob_shifts", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editShift = (obj) => {
    return axios
      .patch("/admin/editPartiCularjob_shifts/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteShift = (obj) => {
    return axios
      .get("/admin/job_shifts/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllOwner = (obj) => {
    return axios
      .get(
        "/admin/getownership_types?page=" +
          obj.page +
          "&page_size=" +
          obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getOwner = (obj) => {
    return axios
      .get("/admin/editownership_types/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addOwner = (obj) => {
    return axios
      .post("/admin/addownership_types", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editOwner = (obj) => {
    return axios
      .patch("/admin/editPartiCularownership_types/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteOwner = (obj) => {
    return axios
      .get("/admin/ownership_types/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllType = (obj) => {
    return axios
      .get("/admin/getjob_types?page=" + obj.page + "&page_size=" + obj.page_size)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getType = (obj) => {
    return axios
      .get("/admin/editjob_types/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addType = (obj) => {
    return axios
      .post("/admin/addjob_types", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editType = (obj) => {
    return axios
      .patch("/admin/editPartiCularjob_types/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteType = (obj) => {
    return axios
      .get("/admin/job_types/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllCurrency = (obj) => {
    return axios
      .get(
        "/admin/getsalary_currencies?page=" +
          obj.page +
          "&page_size=" +
          obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getCurrency = (obj) => {
    return axios
      .get("/admin/editsalary_currencies/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addCurrency = (obj) => {
    return axios
      .post("/admin/addsalary_currencies", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editCurrency = (obj) => {
    return axios
      .patch("/admin/editPartiCularsalary_currencies/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteCurrency = (obj) => {
    return axios
      .get("/admin/salary_currencies/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllPeriod = (obj) => {
    return axios
      .get(
        "/admin/getsalary_periods?page=" +
          obj.page +
          "&page_size=" +
          obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getPeriod = (obj) => {
    return axios
      .get("/admin/editsalary_periods/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addPeriod = (obj) => {
    return axios
      .post("/admin/addsalary_periods", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editPeriod = (obj) => {
    return axios
      .patch("/admin/editPartiCularsalary_periods/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deletePeriod = (obj) => {
    return axios
      .get("/admin/salary_periods/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllSkill = (obj) => {
    return axios
      .get("/admin/getskills?page=" + obj.page + "&page_size=" + obj.page_size)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getSkill = (obj) => {
    return axios
      .get("/admin/editskills/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addSkill = (obj) => {
    return axios
      .post("/admin/addskills", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editSkill = (obj) => {
    return axios
      .patch("/admin/editPartiCularskills/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteSkill = (obj) => {
    return axios
      .get("/admin/skills/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllPosition = (obj) => {
    return axios
      .get(
        "/admin/getPosition?page=" + obj.page + "&page_size=" + obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getPosition = (obj) => {
    return axios
      .get("/admin/editPosition/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addPosition = (obj) => {
    return axios
      .post("/admin/addPosition", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editPosition = (obj) => {
    return axios
      .patch("/admin/editPartiCularPosition/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deletePosition = (obj) => {
    return axios
      .get("/admin/Position/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllContact = (obj) => {
    return axios
      .get(
        "/getcontact?page=" + obj.page + "&page_size=" + obj.page_size
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getContact = (obj) => {
    return axios
      .get("/editcontact/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editContact = (obj) => {
    return axios
      .patch("/editPartiCularcontact/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getAllCount = (obj) => {
    return axios
      .get("/Allcount/")
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };

  export const getcountry = (obj) => {
    return axios
      .get("/country/")
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getstate = (obj) => {
    return axios
      .get("/state/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getcity = (obj) => {
    return axios
      .get("/city/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  //question
export const allQuestion = (obj) => {
  return axios
    .get("/job/getQuestion/" + obj.id)
    .then((response) => {
      return response.data.data;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const getQuestion = (obj) => {
  console.log(obj);
  return axios
    .get("/job/editQuestion/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const addQuestion = (obj) => {
  return axios
    .post("/job/addQuestion", obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const editQuestion = (obj) => {
  return axios
    .patch("/job/editPartiCularQuestion/" + obj.id, obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const deleteQuestion = (obj) => {
  return axios
    .get("/job/Question/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const allQuestionOptions = (obj) => {
  return axios
    .get("/job/getQuestionOption/" + obj.id)
    .then((response) => {
      console.log(response.data.data);
      return response.data.data;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

  //question template
  export const allQuestionTemplate = (obj) => {
    return axios
      .get("/job/getQuestionTemplate?page=" + obj.page + "&page_size=" + obj.page_size)
      .then((response) => {
        // console.log(response.data.data);
        return response.data.data;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const getQuestionTemplate = (obj) => {
    console.log(obj);
    return axios
      .get("/job/editQuestionTemplate/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const addQuestionTemplate = (obj) => {
    return axios
      .post("/job/addQuestionTemplate", obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const editQuestionTemplate = (obj) => {
    return axios
      .patch("/job/editPartiCularQuestionTemplate/" + obj.id, obj.data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
  export const deleteQuestionTemplate = (obj) => {
    return axios
      .get("/job/QuestionTemplate/" + obj.id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log("Error", err.response.data.message);
        return err.response;
      });
  };
  
//course
export const getAllCourse = (obj) => {
  return axios
    .get(
      "/admin/getCourse?page=" + obj.page + "&page_size=" + obj.page_size
    )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const getCourse = (obj) => {
  return axios
    .get("/admin/editCourse/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const addCourse = (obj) => {
  return axios
    .post("/admin/addCourse", obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const editCourse = (obj) => {
  return axios
    .patch("/admin/editPartiCularcourse/" + obj.id, obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const deleteCourse = (obj) => {
  return axios
    .get("/admin/Course/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

//specialization
export const getAllSpecialization = (obj) => {
  return axios
    .get(
      "/admin/getspecialization?page=" + obj.page + "&page_size=" + obj.page_size
    )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const getSpecialization = (obj) => {
  return axios
    .get("/admin/editspecialization/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const addSpecialization = (obj) => {
  return axios
    .post("/admin/addspecialization", obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const editSpecialization = (obj) => {
  return axios
    .patch("/admin/editPartiCularspecialization/" + obj.id, obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const deleteSpecialization = (obj) => {
  return axios
    .get("/admin/specialization/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const loadAllCourses = () => {
  return axios
    .get("/admin/getAllCourses")
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const searchCandidate = (obj) => {
  return axios
    .get("/admin/candsearchform", obj.data, {
      headers: { Authorization: `Bearer ${obj.token}` },
    })
    .then((response) => {      
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const searchFilteredCand = (obj) => {
  console.log(obj);
  return axios
    .get("/admin/candfilter?page=" + obj.page + "&page_size=" + obj.page_size + "&search=" + obj.search)
    .then((response) => {      
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const searchFilteredFirstCand = (obj) => {
  console.log(obj);
  return axios
    .get("/admin/candfilterfirst?page=" + obj.page + "&page_size=" + obj.page_size)
    .then((response) => {      
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const candidateJobAssign = (obj) => {
  return axios
    .post("/admin/candidatejobassign", obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const pendingJobsByEmployer = (obj) => {
  return axios
    .get("/admin/filterjobbyemployeravail/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const statusCandidate = (obj) => {
  return axios
    .post("/admin/candidatestatus/", obj.data, {
      // headers: { Authorization: `Bearer ${obj.token}` },
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const changeStatusCandidateRemark = (obj) => {
  return axios
    .post("/admin/candidatestatusremark/", obj.data, {
      // headers: { Authorization: `Bearer ${obj.token}` },
    })
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const editstatusCandidate = (obj) => {
  return axios
    .post("/admin/candidatestatusedit/", obj.data, {
      // headers: { Authorization: `Bearer ${obj.token}` },
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const addcandidateprofile = (obj) => {
  return axios
    .post("/admin/addcandidate/", obj.data, {
      // headers: { mode: "no-cors", 'Content-Type': 'application/x-www-form-urlencoded', Authorization: `Bearer ${obj.token}` },
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
};

export const editcandidateprofile = (obj) => {
  return axios
    .post("/admin/editcandidate/" + obj.id, obj.data, {
      // headers: { mode: "no-cors", 'Content-Type': 'application/x-www-form-urlencoded', Authorization: `Bearer ${obj.token}` },
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
};


//user
export const getAllUser = (obj) => {
  return axios
    .get(
      "/admin/getuser?page=" + obj.page + "&page_size=" + obj.page_size + "&admin_id=" + obj.admin_id
    )
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const getUser = (obj) => {
  return axios
    .get("/admin/edituser/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const addUser = (obj) => {
  return axios
    .post("/admin/adduser", obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const editUser = (obj) => {
  return axios
    .post("/admin/editPartiCularuser/" + obj.id, obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const deleteUser = (obj) => {
  return axios
    .get("/admin/user/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const mailProfileForUpdate = (obj) => {
  return axios
    .get("/admin/cand/mailcandprofileedit" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};


export const getAllSource = (obj) => {
  return axios
    .get("/admin/getsources?page=" + obj.page + "&page_size=" + obj.page_size)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const getSource = (obj) => {
  return axios
    .get("/admin/editsources/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const addSource = (obj) => {
  return axios
    .post("/admin/addsources", obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const editSource = (obj) => {
  return axios
    .patch("/admin/editPartiCularsources/" + obj.id, obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const deleteSource = (obj) => {
  return axios
    .get("/admin/sources/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const getCandidateStatus = (obj) => {
  return axios
    .get("/admin/editcandidate_status/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const editCandidateStatus = (obj) => {
  return axios
    .patch("/admin/updateCandidateStatus/" + obj.id, obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const deleteCandidateStatus = (obj) => {
  return axios
    .get("/admin/CandidateStatusDelete/" + obj.id +"/"+ obj.user_id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const getCandidateFU = (obj) => {
  console.log(obj);
  return axios
    .get("/admin/editcandidate_fu/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const getCandidateStatusAll = (obj) => {
  return axios
    .get("/admin/getstatuswise?page=" + obj.page + "&page_size=" + obj.page_size + "&search=" + obj.search + "&status=" + obj.status + "&fromdate=" + obj.from_date + "&todate=" + obj.to_date)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const getCandidateFollowUpAll = (obj) => {
  return axios
    .get("/admin/getfollowupwise?page=" + obj.page + "&page_size=" + obj.page_size + "&search=" + obj.search + "&status=" + obj.status + "&fromdate=" + obj.from_date + "&todate=" + obj.to_date)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const addCandidateFollowup = (obj) => {
  return axios
    .post("/admin/statusCandidateRemark", obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const editCandidateFollowup = (obj) => {
  return axios
    .patch("/admin/editPartiCularCandidateFollowup/" + obj.id, obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const deleteCandidateFollowup = (obj) => {
  return axios
    .patch("/admin/CandidateFollowup/" + obj.id, obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const getCandidatesAnswers = (obj) => {
  return axios
    .get(
      "/admin/getanswers/" + obj.job_id + "/" + obj.cand_id
      )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

//email
export const getAllEmail = (obj) => {
  return axios
    .get(
      "/admin/getEmail?page=" + obj.page + "&page_size=" + obj.page_size + "&user_id=" + obj.user_id
    )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const getEmail = (obj) => {
  return axios
    .get("/admin/editEmail/" + obj.id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const addEmail = (obj) => {
  return axios
    .post("/admin/addEmail", obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const editEmail = (obj) => {
  return axios
    .patch("/admin/editPartiCularemail/" + obj.id, obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const deleteEmail = (obj) => {
  return axios
    .get("/admin/Email/" + obj.id + "/" + obj.user_id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};

export const importFromResume = (obj) => {
  return axios
    .post("/admin/parseresume", obj.data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log("Error", err.response.data.message);
      return err.response;
    });
};
